<template>
  <div class="layout-wrapper layout-content-navbar">
      <span>Loading</span>
  </div>
</template>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
